<template>
  <div
    class="login-container flex flex-row justify-end align-center"
  >
    <div class="login-body-container flex flex-col align-center">
      <div class="login-form-head flex flex-col">
        <div class="head-title flex flex-row align-center justify-center">
          <img class="logo" src="@/assets/login/logo.png" alt="logo">
          <span class="title">
            导萃门诊管理系统
          </span>
        </div>
        <img class="divider-line w-full" src="@/assets/login/Rectangle.png" alt="分割线">
      </div>
      <div class="login-form w-full">
        <el-form
          ref="formData"
          :model="formData"
          :rules="rules"
          auto-complete="on"
          label-position="left"
        >
          <el-form-item prop="username">
            <div class="login-input flex flex-row align-center">
              <div class="icon-con h-full flex flex-row align-center">
                <svg-icon class-name="icon" icon-class="user" />
              </div>
              <el-input
                v-model="formData.userCode"
                class="h-full background-white login-input-inner"
                type="text"
                @keyup.enter.native="login"
              />
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="login-input flex flex-row align-center">
              <div class="icon-con h-full flex flex-row align-center">
                <svg-icon icon-class="lock" />
              </div>
              <el-input
                v-model="formData.passWord"
                :type="passwordType"
                class="h-full background-white login-input-inner"
                @keyup.enter.native="login"
              >
                <template #suffix>
                  <span class="icon-con eye-icon h-full flex flex-row align-center" @click="showPwd">
                    <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
                  </span>
                </template>
              </el-input>
            </div>
          </el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            class="login-btn"
            @click.native.prevent="login"
          >登录
          </el-button>
        </el-form>
      </div>

      <div class="form-divider-line w-full" />
      <div class="footer w-full flex flex-row justify-center align-center" @click="goto">
        鲁ICP备2025152110号-1
      </div>
    </div>
  </div>
</template>

<script>
import { postData } from '@/api/ik/data/dataApi'
import md5 from 'js-md5'

export default {
  name: 'Login',
  data() {
    return {
      timer: 0,
      formData: {
        userCode: '',
        passWord: '',
        type: '1'
      },
      rules: {
        userCode: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在6到15个字符', trigger: 'blur' }
        ],
        passWord: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          { min: 6, max: 30, message: '长度在6到30个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      passwordType: 'password',
      title: this.$store.getters['setting/getTitle']
    }
  },
  methods: {
    goto() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index")
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    login() {
      const currentUserCode = this.formData.userCode
      const currentPassword = md5(this.formData.passWord)

      if (currentUserCode.length === 13) {
        this.formData.type = '2'
      }

      const pd = {
        code: currentUserCode,
        password: currentPassword,
        type: this.formData.type
      }
      this.loading = true
      postData('base/user/user/storeuser/do/storelogin', pd)
        .then(response => {
          this.$store.dispatch('user/login', {
            'token': response.data.token,
            'userCode': response.data.code,
            'userName': response.data.name,
            'userRole': response.data.userRole,
            'storeId': response.data.storeId,
            'storeCode': response.data.storeCode,
            'storeName': response.data.storeName,
            'securityLevel': '',
            'fieldSecurityLevel': '',
            'doctorType': response.data.doctorType,
            'pharmacistType': response.data.pharmacistType,
            'baseUserId': response.data.baseUserId
          })
          localStorage.setItem('user', JSON.stringify(this.$store.state.user))
          const targetPath = this.redirect || '/base/home'
          this.$router.push({ path: targetPath })
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  border-color: transparent;
  height: 100%;
  background-color: #ffffff !important;
  &:hover {
    border-color: transparent;
  }
}
.login-container {
  background-image: url("../../../../assets/login/BG.png");
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: left center;
  height: 100vh;
  background-color: #F9FAFC;
  .login-body-container {
    margin-right: 200px;
    background-color: #FFFFFF;
    padding: 27px 0 0 0;
    width: 504px;
    height: 490px;
    .login-form-head {
      margin-bottom: 40px;
      .head-title {
        margin-bottom: 23px;
        .logo {
          width: 36px;
          height: 36px;
          margin-right: 16px;
        }
        .title {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: 500;
          font-size: 20px;
          color: #333333;
          line-height: 23px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
      .divider-line {
        height: 10px;
      }
    }
    .login-form {
      padding: 0 40px 0 40px;
      margin-bottom: 55px;
      .login-input {
        width: 424px;
        height: 52px;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 2px solid #EFF3F5;
        margin-bottom: 35px;
        .icon-con {
          padding: 0 20px;
          .icon {
            font-size: 16px;
          }
          .eye-icon {
            cursor: pointer;
          }
        }
      }
      .login-btn {
        width: 424px;
        height: 50px;
        background: linear-gradient(90deg, #026CFF 0%, #00A3FE 100%);
        border-radius: 8px 8px 8px 8px;
      }
    }
    .form-divider-line {
      height: 4px;
      background: linear-gradient(180deg, rgba(142, 145, 147, 0.1) 0%, rgba(241, 245, 249, 0) 100%);
      opacity: 0.5;
      margin-bottom: 17px;
    }
    .footer {
      font-family: PingFang SC, PingFang SC, serif;
      font-weight: 400;
      font-size: 12px;
      color: #9DA7B4;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
